module.exports = __webpack_public_path__ + "img/fruit_grapefruit.80214c47.png";